import { render, staticRenderFns } from "./MyPageInfoUpdate.vue?vue&type=template&id=88edd1b0&scoped=true"
import script from "./MyPageInfoUpdate.vue?vue&type=script&lang=js"
export * from "./MyPageInfoUpdate.vue?vue&type=script&lang=js"
import style1 from "./MyPageInfoUpdate.vue?vue&type=style&index=1&id=88edd1b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88edd1b0",
  null
  
)

export default component.exports